const C_AGENT_BASE_PATH = '/agent/'
export enum AgentApiPath {
  /**
   * 登陆
   */
  Login = `${C_AGENT_BASE_PATH}agentLogin`,
  /**
   * 修改密码
   */
  ModifyPassword = `${C_AGENT_BASE_PATH}agentModifyPassword`,
  /**
   * 获取用户信息
   */
  UserInfo = `${C_AGENT_BASE_PATH}userInfo`,
  /**
   * 获取连接列表
   */
  GetLinks = `${C_AGENT_BASE_PATH}getAgentLinks`,
  /**
   * 添加链接接口
   */
  AddLink = `${C_AGENT_BASE_PATH}agentAddLinks`,

  /**
   * 获取仪表盘数据
   */
  GetDashboard = `${C_AGENT_BASE_PATH}operationData/getDashboard`,

  /**
   * 获取收入
   */
  GetIncomes = `${C_AGENT_BASE_PATH}operationData/getIncomes`,

  /**
   * 获取记录
   */
  GetRecords = `${C_AGENT_BASE_PATH}operationData/getRecords`,
  /**
   * 获取规则
   */
  GetRules = `${C_AGENT_BASE_PATH}operationData/getRules`
}
